export default function ExpandHorizontalIcon(props: { fill?: string }) {
  const color = props.fill ?? 'white';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      role="img"
      viewBox="0 0 20 20"
    >
      {/* central vertical bar */}
      <line
        x1="10"
        y1="3"
        x2="10"
        y2="17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* left pointing‑left arrow */}
      <line
        x1="8"
        y1="10"
        x2="2.5"
        y2="10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <polyline
        points="4.5 7 1.5 10 4.5 13"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* right pointing‑right arrow */}
      <line
        x1="12"
        y1="10"
        x2="17.5"
        y2="10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <polyline
        points="15.5 7 18.5 10 15.5 13"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
